import React, { useState } from 'react'
import ReactTable from 'react-table'
import moment from 'moment'
import { Query } from 'react-apollo'
import _ from 'lodash'
import FileDownload from 'js-file-download'
import axios from 'axios'
import {
  Div, H3, Button, Loading, P, DynamicButtonLink,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { Wrapper } from '../../../components/gas-components'
import { GAS_STATION_LIST } from '../../../constants/graphql/query'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { monthConverter } from '../../../utils/util-services'
import './style-css.css'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

const download = (setIsLoading) => {
  axios({
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
    url: `${getURL().FILE_SERVER}/download/gasstation`,
  }).then((resp) => {
    FileDownload(resp.data, `ข้อมูลสถานีเติมน้ำมัน วันที่ ${moment().format('DD')} ${monthConverter(moment().format('MM'))} ${parseInt(moment().format('YYYY'), 10) + 543}.xls`)
    setIsLoading(false)
  })
}

const Index = () => {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <Div display='flex' flexDirection='column'>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>รายการปั๊มน้ำมัน</H3>
        <Div display='flex' flexDirection='row' justifyContent='space-between'>
          <Button
            disabled={!_.includes(window.perms, PERMISSION.EXPORT_GAS_STATION) || isLoading}
            loading={isLoading}
            inverse
            text='Export'
            onClick={() => {
              setIsLoading(true)
              download(setIsLoading)
            }}
            margin='0 16px 0 0' />
          <DynamicButtonLink link='/gas-station/add' condition={_.includes(window.perms, PERMISSION.CREATE_GAS_STATION)} props={{ text: 'สร้างปั้มน้ำมัน' }}/>
        </Div>
      </Div>
      <List/>
    </Div>
  )
}

export const List = () => {
  const [filtered, setFiltered] = useState()
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  const [current, setCurrent] = useState(0)
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      <Query
        query={GAS_STATION_LIST}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <Div>
            <ReactTable
              className='table'
              data={data.GasstationList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: `3px solid ${color.primaryColor}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.GasstationList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  Object.assign(newOjb, { [v.id]: v.value })
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>

    </Wrapper>
  )
}
export default Index
